import { Injectable } from '@angular/core';
var RandomId = (function () {
    function RandomId() {
    }
    Object.defineProperty(RandomId.prototype, "generate", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ id = (Math.random() + Date.now());
            return id;
        },
        enumerable: true,
        configurable: true
    });
    return RandomId;
}());
export { RandomId };
RandomId.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
RandomId.ctorParameters = function () { return []; };
function RandomId_tsickle_Closure_declarations() {
    /** @type {?} */
    RandomId.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RandomId.ctorParameters;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/core/ly/random-id.js
// module id = 696
// module chunks = 31